import type { QueryClient } from '@tanstack/react-query';

import type { PeopleProfile } from '@/common/api/models/peopleProfile';

const GSS_OCCASION_PEOPLE_QUERY_PREFIX = '/connections/occasions/gss/';

type ShareableProfile = Pick<PeopleProfile, 'shareEmail' | 'phone' | 'whatsapp' | 'sharePhone' | 'shareWhatsapp'>;

/** Whether the owner profile includes at least one shareable contact (G-5). */
export function hasShareableContact(profile: ShareableProfile): boolean {
  if (profile.shareEmail?.trim()) return true;
  if (profile.phone?.trim() && profile.sharePhone) return true;
  if (profile.whatsapp?.trim() && profile.shareWhatsapp) return true;
  return false;
}

/** AC-11.4: refetch all slot occasion lists after profile save (any slot id). */
export function invalidateAllGssOccasionPeopleQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const first = query.queryKey[0];
      return typeof first === 'string' && first.startsWith(GSS_OCCASION_PEOPLE_QUERY_PREFIX);
    },
  });
}
